import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator to check if password and confirmPassword fields match
export function MustMatch(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl) => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
      // Return if another validator has already found an error on the matchingControl
      return null;
    }

    // Set an error on the matchingControl if validation fails
    if (control?.value !== matchingControl?.value) {
      matchingControl?.setErrors({ mustMatch: true });
    } else {
      matchingControl?.setErrors(null);
    }
    return null;
  };
}
